import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BusinessService {
  constructor(public http: HttpClient, private router: Router) {}
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  base_url = environment.apiUrl;

  addBusiness(data: any): Observable<any> {
    return this.http
      .post(this.base_url + `organization/business`, data, {
        headers: this.headers,
      })
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  getBusinesses(): Observable<any> {
    return this.http.get(this.base_url + 'organization/business').pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
  getDetails(): Observable<any> {
    return this.http.get(this.base_url + 'organization').pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
  switchBusiness(id: string): Observable<any> {
    return this.http.get(this.base_url + `organization/switch/business/${id}`).pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
}


